import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import hoistNonReactStatic from 'hoist-non-react-statics';

import PageLoader from 'components/PageLoading';

function withPageLoader({ loadingSelector, initialAction, initialActionArgsSelector = () => {} }) {
  return WrappedComponent => {
    class NewComponent extends Component {
      static propTypes = {
        initialActionFunc: PropTypes.func,
        loading: PropTypes.bool.isRequired,
        initActionArgs: PropTypes.any, // eslint-disable-line react/forbid-prop-types
      };

      static defaultProps = {
        initialActionFunc: null,
        initActionArgs: {},
      };

      componentDidMount() {
        const { initialActionFunc, initActionArgs } = this.props;
        if (initialActionFunc) {
          initialActionFunc(initActionArgs);
        }
      }

      render() {
        const { loading } = this.props;

        if (loading) {
          return <PageLoader />;
        }
        return <WrappedComponent {...this.props} />;
      }
    }

    hoistNonReactStatic(NewComponent, WrappedComponent);

    const mapStateToProps = (state, ownProps) => ({
      loading: loadingSelector(state, ownProps),
      initActionArgs: initialActionArgsSelector(state),
    });

    const mapDispatchToProps = {
      initialActionFunc: initialAction,
    };

    return connect(
      mapStateToProps,
      mapDispatchToProps,
    )(NewComponent);
  };
}

export default withPageLoader;
